 /**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, OnInit } from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import { InputData } from 'src/app/_common/data/input-data';

import { Language } from  "../../service/constant";

@Component({
  selector: 'vision-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent{

  lang:string = Language.ENGLISH;
  shortName:string = "FR";
  longName:string = "français";

  constructor(private translate: TranslateService,public data:InputData) { 

       this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

        if ( event.lang == Language.FRENCH ) {
             this.lang = Language.FRENCH;
             this.shortName = "EN";
             this.longName = "English";
        }
        else {
             this.lang = Language.ENGLISH;
             this.shortName = "FR";
             this.longName = "français";
        }
      });
  }

  public onLangChange() {

       if ( this.lang == Language.ENGLISH ) {
            this.lang = Language.FRENCH;
       }
       else {
            this.lang = Language.ENGLISH;
       }

       this.translate.use(this.lang);

        //event.preventDefault();
        return false;
  }

  public keyPress(event:any) {
      if ( event.keyCode == 13 ) {
           this.onLangChange();        
      }
      }

}
